import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaInstagram,
//   FaLinkedinIn,
// } from "react-icons/fa";
import { catalogApi } from "../api/client"; // Import your API client

// Use the same links as your Navbar
const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "About Us", path: "/about" },
  { name: "Blogs", path: "/blogs" },
];

const shortCategoryNames = {
  "Accounting & CA": "Accounts",
  "Automobiles / Auto Parts": "Automobiles",
  "Book / Stationary Store": "Stationary",
  "Chemicals & Fertilizers": "Fertilizers",
};

const Footer = () => {
  const [footerCategories, setFooterCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch categories from backend using client.js
    catalogApi
      .listCategories()
      .then((data) => setFooterCategories((data.items || []).slice(0, 4)))
      .catch(() => setFooterCategories([]));
  }, []);

  const handleCategoryClick = (category) => {
    navigate(`/services?categoryIds=${category._id}`);
  };

  return (
    <footer className="bg-gradient-to-r from-blue-700 to-neutral-900 text-gray-300 py-10 px-6 text-center poppins-regular">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-center ">
        <div>
          <img
            className="w-48 h-48 hidden lg:block"
            src="https://cdn.pixabay.com/animation/2023/05/22/20/17/20-17-27-433_512.gif"
            alt="world gif"
          />
        </div>
        {/* Logo / About */}
        <div>
          <h2 className="text-white text-xl font-bold mb-4">
            Online Indian Market
          </h2>
          <p className="text-sm">
            Bringing local Indian markets online. Find nearby services and
            businesses with ease.
          </p>
        </div>

        {/* Navigation */}
        <div className="hidden lg:block">
          <h3 className="text-white font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <a href={link.path} className="hover:text-white">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Categories */}
        <div className="hidden lg:block">
          <h3 className="text-white font-semibold mb-4">Categories</h3>
          <ul className="space-y-2 text-sm">
            {footerCategories.length === 0 ? (
              <li className="text-gray-400">No categories</li>
            ) : (
              footerCategories.map((cat) => (
                <li key={cat._id}>
                  <button
                    className="hover:text-white bg-transparent p-0 m-0 border-none outline-none cursor-pointer"
                    onClick={() => handleCategoryClick(cat)}
                  >
                    {cat.name}
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>

        <div className=" block lg:hidden ">
          <div className="grid grid-cols-2">
            {/* Navigation */}
            <div>
              <h3 className="text-white font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                {NAV_LINKS.map((link) => (
                  <li key={link.path}>
                    <a href={link.path} className="hover:text-white">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h3 className="text-white font-semibold  mb-4">Categories</h3>
              <ul className="space-y-2 text-sm">
                {footerCategories.length === 0 ? (
                  <li className="text-gray-400">No categories</li>
                ) : (
                  footerCategories.map((cat) => (
                    <li key={cat._id}>
                      <button
                        className="hover:text-white bg-transparent p-0 m-0 border-none outline-none cursor-pointer"
                        onClick={() => handleCategoryClick(cat)}
                      >
                        <li>{shortCategoryNames[cat.name] || cat.name}</li>
                      </button>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
